<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline primary white--text">{{memberType === '32' ? $t('lang.individualMemberVerification') : $t('lang.organizationMemberVerification')}}</v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form" class="mt-4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-textarea :rows="(memberType === '33' && $store.getters.getLanguage !== 0 && isMobile()) ? 2 : 1" dense v-model="name" outlined clearable required :rules="nullRules" :placeholder="memberType === '32' ? $t('lang.name') : $t('lang.teamName')"></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea :rows="(memberType === '33' && (isMobile() || $store.getters.getLanguage !== 0)) ? 2 : 1" dense v-model="code" outlined clearable required :rules="nullRules" :placeholder="memberType === '32' ? $t('lang.ids2') : $t('lang.organizationCode')"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" dense>
            <v-col cols="5">
              <v-btn block  style="text-transform:none;" @click="dialog = false;$emit('isMemberVerification', false)">{{$t('lang.cancel')}}</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn block style="text-transform:none;" color="primary" @click="login()">{{$t('lang.confirm')}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDialog" persistent max-width="290" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="headline">{{$t('lang.tips')}}</v-card-title>
        <v-card-text v-text="msg" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="showDialog = false">
            {{$t('lang.confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style>
textarea {
  resize : none;
}
</style>
<script>
import utils from '../utils/utils'
export default {
  name: 'MemberVerification',
  props: ['id', 'memberType', 'constId'],
  computed: {
  },
  data () {
    return {
      dialog: true,
      showDialog: false,
      disabled: false,
      msg: '',
      name: '',
      code: '',
      nullRules: []
    }
  },
  mounted () {
    this.initRoles()
  },
  methods: {
    initRoles () {
      this.nullRules = [
        v => !!v || this.$t('lang.cannotBeEmpty')
      ]
    },
    isMobile () {
      return utils.methods.isMobile()
    },
    login () {
      if (this.$refs.form.validate()) {
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API',
          url: '/SignUp/VerifyTeamOrPerInfo',
          params: {
            SignUpId: this.id,
            UserName: this.name,
            Card: this.code,
            CostId: this.constId,
            Type: this.memberType === '32' ? 1 : 2 // 1个人会员，2单位会员
          }
        }).then(res => {
          console.log(res)
          if (res.data.ret === 0) {
            this.dialog = false
            this.$emit('isMemberVerification', true)
            this.$emit('verId', res.data.msg)
          } else {
            this.msg = this.$store.getters.getLanguage === 0 ? res.data.msg : res.data.msg_en
            this.showDialog = true
          }
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}
</script>
